
export const LocalStorageKeys = {
  AuthToken: 'SNAPPAuthToken',
  UserData: 'SNAPPUser',
  IntendedUrl: 'SNAPPIntendedUrl',
  Filter: 'SNAPPSearchFilter',
  ShowTrainerMessage: 'SNAPPShowTrainerMessage',
  SessionData: 'SNAPPSessionData',
  UnreadMessagesCount: 'SNAPPUnreadMessagesCount',
};

export const AppEvents = {
  attendanceChanged: 'attendanceChanged',
  paymentMethodsClosed: 'paymentMethodsClosed',
  showPaymentMethods: 'showPaymentMethods',
  searchFilterChanged: 'searchFilterChanged',
};

export const AppAttendanceChangedType = {
  booking: 'booking',
  cancel: 'cancel',
};

export const AppSessionKeys = {
  continueWithBooking: 'continueWithBooking',
  continueWithTiping: 'continueWithTiping',
};

export const BannerTypes = {
  search: 'SEARCH',
  poster: 'POSTER',
  trainer: 'TRAINER',
  specificTraining: 'SPECIFIC_TRAINING',
}

export const AttendanceTypes = {
  member: 'MEMBER',
  nonMember: 'NONMEMBER',
  guest: 'GUEST',
}

export const SearchTypes = {
  search: 'search',
  popup: 'popup',
  discover: 'discover',
};

export const Sweatmeter = {
  all: { label: 'All', val: 1 },
  noSweat: { label: 'No Sweat', val: 2 },
  noSweat2: { label: 'No Sweat', val: 3 },
  someSweat: { label: 'Some Sweat', val: 4 },
  drenched: { label: 'Drenched', val: 5 },
}

export const CourseDifficulty = {
  all: { label: 'All', val: 1 },
  beginner: { label: 'Beginner', val: 2 },
  beginner2: { label: 'Beginner', val: 3 },
  intermediate: { label: 'Intermediate', val: 4 },
  advanced: { label: 'Advanced', val: 5 },
}

export const AppRoutes = {
  landing: {path: '/'},
  home: {path: '/home'},
  login: {path: '/login'},
  signup: {path: '/signup'},
  passwordRecovery: {path: '/password-recovery'},
  passwordChange: {path: '/password-change'},
  resendConfirmation: {path: '/resend-email-confirmation'},
  completeProfile: {path: '/complete-profile'},
  profile: {path: '/profile'},
  following: {path: '/following'},
  schedule: {path: '/schedule'},
  inbox: {path: '/inbox'},
  searchEvents: {path: '/search-events'},
  searchTrainers: {path: '/search-trainers'},
  eventCategories: {path: '/event-categories'},
  trainers: {path: '/trainers'},
  events: {path: '/events'},
  notFound: {path: '/404'},
};

export const Links = {
  terms: 'https://sweatnow.com/terms-and-conditions',
  eula: 'https://sweatnow.com/eula',
  privacyPolicy: 'https://sweatnow.com/privacy-policy',
  paymentsGuide: 'https://sweatnow.com/payments-user-guide',
}

export const ThemeColorMap = [
  '#2b45a9',
  '#737fed',
  '#6b5eae',
  '#ff679b',
  '#fa5c7c',
  '#e7791f',
  '#e3b52c',
  '#5ecb9b',
  '#099aa4',
  '#4bb2d0',
];